<!--
 * @Author: andy_chen
 * @created: 2018-10-23 15:57:46
-->

<template>
    <div class="container">
        <div class="info">
            <div class="avatar">
                <img class="avatar-box" :src="userInfo.headImg | resizeImgShort(140)" :data-large="userInfo.headImg" v-gallery>
            </div>
            <div class="user-detail">
                <p class="user-title">
                    <span class="user-nickname">{{userInfo.nickname}}</span>
                    <span class="user-gender-box">
                        <gender :age="userInfo.age" :gender="userInfo.sex"/>
                    </span>
                </p>
                <p class="user-sign">{{userInfo.signature}}</p>
                <div class="operate-box">
                    <router-link v-if="!userInfo.phone" to="/bindPhone" class="operate-btn">
                        <svg-icon class="bind-phone-icon" icon-class="bind-phone"/>绑定手机
                    </router-link>
                    <p v-else to="/bindPhone" class="operate-btn">
                        <svg-icon class="bind-phone-icon" icon-class="bind-phone"/>已绑定手机
                    </p>
                    <router-link to="/editProfile" class="operate-btn">完善资料</router-link>
                </div>
                <div class="edit-icon-box" @click="handleGoEdit">
                    <svg-icon class="edit-icon" icon-class="edit"/>
                </div>
            </div>
        </div>
        <div class="situation-list">
            <router-link to="/visitorList" class="situation-item">
                <p class="situation-num">{{userInfo.browseNum || 0}}</p>
                <p>谁看过我</p>
            </router-link>
            <router-link to="/joinMeList" class="situation-item">
                <p class="situation-num">{{userInfo.likeNum || 0}}</p>
                <p>谁想和我去</p>
            </router-link>
            <router-link to="/replyMeList" class="situation-item">
                <p class="situation-num">
                    {{userInfo.replyNum || 0}}
                    <span v-if="userInfo.newReplyMsg" class="new-msg"></span>
                </p>
                <p>收到的回复</p>
            </router-link>
            <router-link to="/fans" class="situation-item">
                <p class="situation-num">
                    {{userInfo.fansNum || 0}}
                    <span v-if="userInfo.newFocusMsg" class="new-msg"></span>
                </p>
                <p>粉丝</p>
            </router-link>
        </div>
        <list-item title="我发布的" :to="`/myPublish/${userInfo.userId}`" :hasBottomLine="true" class="top-split-line"></list-item>
        <list-item title="我关注的" :to="`/followers/${userInfo.userId}`" :hasBottomLine="true" class></list-item>
        <list-item title="我想去的" :to="`/myFavor/${userInfo.userId}`" :hasBottomLine="true" class></list-item>
        <list-item title="我的资料" to="/editProfile" :hasBottomLine="true" class></list-item>
        <list-item v-if="$env.isTravelCatApp" title="设置" to="/setting" :hasBottomLine="true"></list-item>
        <compose-btn v-if="!$env.isTravelCatApp"></compose-btn>
    </div>
</template>

<script>
import * as userService from "../api/user.js";
import Gender from "../components/UserInfo/Gender";
import ComposeBtn from "../components/ComposeBtn/index";
import ListItem from "../components/ListItem";
import nativeApi from "../nativeApi/index.js";
import { AlertBox } from "../components/Alert/index.js";

export default {
    name: "My",
    components: {
        Gender,
        ComposeBtn,
        ListItem
    },
    data() {
        return {
            userInfo: {
                headImg: ""
            }
        };
    },

    created() {
        // 监听原生登录成功
        if (this.$env.isTravelCatApp) {
            nativeApi.listenAfterLogin(res => {
                console.log("app login success");
                // 已绑定手机号
                let token = res.data.token;
                this.$loading.open();
                this.$store.dispatch("AfterAppLogin", token).then(() => {
                    this.$loading.close();
                    if (!this.$store.getters.userInfo.phone) {
                        this.$router.push({ path: "/bindPhone" });
                    } else if (!this.isCompleteInfo()) {
                        this.showAlertBox();
                    }
                    this.initUserData();
                });
            });

            // 监听退出登陆
            nativeApi.listenAfterLogout(() => {
                console.log("app logout success");
                this.$store.dispatch("FedLogOut");
            });
        }
    },

    mounted() {
        this.initUserData();
        if (this.$env.isTravelCatApp) {
            nativeApi.onVisibilityChange(visibile => {
                console.log("native call : onVisibilityChange");
                if (visibile) {
                    this.initUserData();
                }
            });
        }
    },

    methods: {
        initUserData() {
            // 由于在app中my页面是一直常驻的。为了防止弹窗，没有token的时候，不发起请求
            if (this.$env.isTravelCatApp && !this.$store.getters.token) {
                this.showLoginBox();
                return;
            }

            if (this.loginConfirm) {
                this.loginConfirm.hide();
            }

            this.$loading.open({ delay: 500 });
            userService
                .getUserCenterInfo()
                .then(res => {
                    if (+res.code === 200) {
                        this.userInfo = res.data;
                    } else {
                        this.$toast.open({ msg: res.msg });
                    }
                })
                .finally(() => {
                    this.$loading.close();
                });
        },

        handleGoEdit() {
            this.$router.push({ path: "/editProfile" });
        },

        /**
         * 登陆成功显示完善资料的弹窗
         */
        showAlertBox() {
            // 使用对象
            this.$messageBox({
                title: "去完善个人资料让大家更好地认识你",
                buttonList: ["不了，谢谢", "去完善资料"]
            }).then(result => {
                if (result === 1) {
                    // 去完善资料
                    this.$router.push({ path: "/editProfile" });
                }
            });
        },

        showLoginBox() {
            if (this.$env.isTravelCatApp) {
                if (!this.loginConfirm) {
                    this.loginConfirm = new AlertBox({
                        type: "conform",
                        title: "登录信息已过期",
                        buttonList: ["去登录"],
                        callback: () => {
                            nativeApi.goLoginPage(window.location.href);
                        }
                    });
                }
                this.loginConfirm.show();
            }
        },

        isCompleteInfo() {
            let userInfo = this.$store.getters.userInfo || {};
            let keys = ["nickname", "signature", "sex", "bornDate", "region"];
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                let value = userInfo[key];
                if (typeof value === "undefined" || (value + "").length === 0) {
                    return false;
                }
            }
            return true;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

.container {
    background: $baseBackgroundColor;
}

.info {
    background: #fff;
    display: flex;
    padding: 0.3rem;
    position: relative;

    .edit-icon-box {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0.35rem;
        width: 1rem;
        height: 1rem;
    }

    .edit-icon {
        position: absolute;
        top: 0.3rem;
        right: 0.3rem;
        font-size: 0.35rem;
    }

    .avatar {
        flex-basis: 1.6rem;
    }

    .avatar-box {
        width: 1.4rem;
        height: 1.4rem;
        border: 1px solid rgba(153, 153, 153, 0.5);
        overflow: hidden;
        border-radius: 50%;
        // background-repeat: no-repeat;
        // background-position: center;
        // background-size: cover;
        object-fit: cover;
    }

    .user-detail {
        flex: 1;
        // padding-left: 0.1rem;
        overflow: hidden;
    }

    .user-title {
        font-size: 0.36rem;
        color: $baseColor;
        font-weight: bold;
        padding-right: 0.5rem;
        display: flex;
        line-height: normal;
    }

    .user-nickname {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .user-gender-box {
        flex: 1;
        min-width: 0.8rem;
        padding-left: 0.08rem;
        .user-gender {
            width: 0.74rem;
            height: 0.36rem;
            font-size: 0.26rem;
        }
    }

    .user-sign {
        font-size: 0.28rem;
        color: $secondaryColor;
        padding-top: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .operate-box {
        padding-top: 0.15rem;
        display: flex;
        align-items: center;
    }

    .operate-btn {
        display: inline-flex;
        border: 1px solid #c0c0c0;
        border-radius: 0.22rem;
        height: 0.4rem;
        padding: 0 0.14rem;
        text-decoration: none;
        color: $secondaryColor;
        font-size: 0.24rem;
        margin-right: 0.18rem;
        align-items: center;
        justify-content: center;
        line-height: normal;
        box-sizing: border-box;
        outline: none;
        vertical-align: middle;
    }
}

.situation-list {
    display: flex;
}

.situation-item {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: $baseColor;
    font-size: 0.24rem;
    height: 1.4rem;
    background: #fff;
    border-top: 1px solid #e5e5e5;
}

.situation-num {
    font-weight: bold;
    position: relative;
    margin-bottom: 0.1rem;
    font-size: 0.32rem;
}

.new-msg {
    background: #fe2042;
    width: 0.12rem;
    height: 0.12rem;
    position: absolute;
    top: -0.05rem;
    right: -0.15rem;
    border-radius: 50%;
}

// .list-item {
//     height: 1.1rem;
//     background: #fff;
//     border-bottom: 1px solid #e5e5e5;
//     padding-left: 0.34rem;
//     position: relative;
//     font-size: 0.28rem;
//     color: $baseColor;
//     display: flex;
//     align-items: center;
//     // justify-content: flex-end;
//     box-sizing: border-box;
// }

.top-split-line {
    margin-top: 0.2rem;
}

// .arrow-right {
//     position: absolute;
//     right: 0.2rem;
//     top: 50%;
//     transform: translateY(-50%);
//     font-size: 0.28rem;
//     color: #979797;
// }

// .arrow-icon {
//     transform: rotate(180deg);
// }
</style>
